namespace GeniuzPOS.Administration {
    export interface CsParaRow {
        Id?: number;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TelId?: string;
        FaxId?: string;
        Email?: string;
        RegId?: string;
        TaxId?: string;
        BizType?: string;
        VatFg?: CsParaVatFg;
        TaxInvName?: string;
        TaxInvAddrLine1?: string;
        TaxInvAddrLine2?: string;
        TaxInvAddrLine3?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ErpCompCode?: string;
        SlowMoveItenDate?: number;
        BizNameEn?: string;
        BranchNo?: string;
        BranchNameDesc?: string;
        BranchNameDescEn?: string;
        BuildingName?: string;
        BuildingNo?: string;
        StreetName?: string;
        District?: string;
        City?: string;
        Province?: string;
        BuildingNameEn?: string;
        BuildingNoEn?: string;
        StreetNameEn?: string;
        DistrictEn?: string;
        ProvinceEn?: string;
        CityEn?: string;
        PostalCode?: string;
        CountryCode?: string;
    }

    export namespace CsParaRow {
        export const idProperty = 'Id';
        export const nameProperty = 'BizId';
        export const localTextPrefix = 'Administration.CsPara';
        export const lookupKey = 'Administration.CsPara';

        export function getLookup(): Q.Lookup<CsParaRow> {
            return Q.getLookup<CsParaRow>('Administration.CsPara');
        }
        export const deletePermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:Modify';
        export const insertPermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:Modify';
        export const readPermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:View';
        export const updatePermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:Modify';

        export declare const enum Fields {
            Id = "Id",
            BizName = "BizName",
            BizAddressLine1 = "BizAddressLine1",
            BizAddressLine2 = "BizAddressLine2",
            BizAddressLine3 = "BizAddressLine3",
            TelId = "TelId",
            FaxId = "FaxId",
            Email = "Email",
            RegId = "RegId",
            TaxId = "TaxId",
            BizType = "BizType",
            VatFg = "VatFg",
            TaxInvName = "TaxInvName",
            TaxInvAddrLine1 = "TaxInvAddrLine1",
            TaxInvAddrLine2 = "TaxInvAddrLine2",
            TaxInvAddrLine3 = "TaxInvAddrLine3",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ErpCompCode = "ErpCompCode",
            SlowMoveItenDate = "SlowMoveItenDate",
            BizNameEn = "BizNameEn",
            BranchNo = "BranchNo",
            BranchNameDesc = "BranchNameDesc",
            BranchNameDescEn = "BranchNameDescEn",
            BuildingName = "BuildingName",
            BuildingNo = "BuildingNo",
            StreetName = "StreetName",
            District = "District",
            City = "City",
            Province = "Province",
            BuildingNameEn = "BuildingNameEn",
            BuildingNoEn = "BuildingNoEn",
            StreetNameEn = "StreetNameEn",
            DistrictEn = "DistrictEn",
            ProvinceEn = "ProvinceEn",
            CityEn = "CityEn",
            PostalCode = "PostalCode",
            CountryCode = "CountryCode"
        }
    }
}
